import React, { useEffect, useState } from "react";
import Tables from "./Tables";
import SearchBox from "./common/SearchBox";
import DropdownBox from "./common/DropdownBox";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AddItem from "./modals/AddItem";
import { Nav, Tab } from "react-bootstrap";
import GroupList from "./GroupList";
import { BackIcon } from "../assets/Icons";

const tableHeaders = ["SNo", "Machine Name", "Serial Number", "Model Number", "QR Code"];

const options = [
  { label: "Name (A-Z)", value: "ascName" },
  { label: "Name (Z-A)", value: "descName" },
  { label: "Latest", value: "ascTime" },
  { label: "Oldest", value: "descTime" },
];

const MachineList = () => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [machineList, setMachineList] = useState([]);
  const [addMachine, setAddMachine] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [value, setValue] = useState("ascTime");
  const [activeTab, setActiveTab] = useState("Dashboard");

  const handleSortMachineList = (value) => {
    let sortedList = [...machineList];
    if (value === "ascTime") {
      sortedList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (value === "descTime") {
      sortedList.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    } else if (value === "ascName") {
      sortedList.sort((a, b) => a.name.localeCompare(b.name));
    } else if (value === "descName") {
      sortedList.sort((a, b) => b.name.localeCompare(a.name));
    }
    setMachineList(sortedList);
  };

  let fetchAllMachines = async () => {
    try {
      let { data } = await axios.get(`${configData.config.API_URL}/api/machine/all/${groupId}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      setMachineList(data.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const onSaveMachine = async (machineData, file) => {
    const postData = {
      name: machineData.name,
      machineId: machineData.machineId,
      serialNo: machineData.serialNo ? machineData.serialNo : null,
      tags: machineData.tags,
    };

    try {
      let response = await axios.post(`${configData.config.API_URL}/api/machine/add`, postData, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        let { data } = await axios.post(
          `${configData.config.UNO_URL}/api/resource/machine-monitoring/attachment/${response.data.machineId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        postData.thumbnail = data.url;
      }

      await axios.put(`${configData.config.API_URL}/api/machine/update/${response.data.machineId}`, postData, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      setAddMachine(false);
      setLoadingBtn(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      fetchAllMachines();
    }
  };

  useEffect(() => {
    fetchAllMachines();
  }, [groupId]);

  const loadBox = 4;
  const tableList = [];

  for (let i = 0; i < loadBox; i++) {
    tableList.push(
      <tr key={i}>
        <td className="text-center">
          <Skeleton width="3vw" height="1.65rem" />
        </td>
        <td>
          <Skeleton width="15vw" height="1.65rem" />
        </td>
        <td className="text-center">
          <Skeleton width="10vw" height="1.65rem" />
        </td>
        <td className="text-center">
          <Skeleton width="10vw" height="1.65rem" />
        </td>
        <td className="text-center">
          <Skeleton width="3vw" height="1.65rem" />
        </td>
        <td className="text-center">
          <Skeleton width="5rem" height="5rem" />
        </td>
      </tr>
    );
  }

  return (
    <>
      <Tab.Container id="my-tabs" activeKey={activeTab} defaultActiveKey="Dashboard">
        <Nav className="tabsproduct updated toptab" variant="tabs">
          <Nav.Item>
            <button className="backbtn cursor-pointer mb-1" title="Back" onClick={() => navigate(-1)}>
              <BackIcon />
              Back
            </button>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link onClick={() => setActiveTab("Dashboard")} eventKey="Dashboard">
              Machine List
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link onClick={() => setActiveTab("groups")} eventKey="groups">
              Groups
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <div className="container-fluid admindashboard p-4 pt-4 bg-grey-main">
          <Tab.Content className="pt-3">
            <Tab.Pane eventKey="Dashboard">
              <div className="machines-list">
                <div className="page-title">
                  <h5>Machines</h5>
                  {!loading && (
                    <>
                      {machineList.length > 0 && userData?.user?.permissions?.includes("MACHINE.ADD") ? (
                        <button className="plain-btn" onClick={() => navigate(`/machine-list/create`)}>
                          Add New Machine
                        </button>
                      ) : null}
                    </>
                  )}
                </div>
                <section className="px-4">
                  {!loading ? (
                    <>
                      {machineList.length > 0 ? (
                        <>
                          <div className="tags-sort my-3">
                            <SearchBox search={search} setSearch={setSearch} />
                            <DropdownBox
                              value={value}
                              setValue={setValue}
                              options={options}
                              handleSortMachineList={handleSortMachineList}
                            />
                          </div>
                          <Tables
                            search={search}
                            tableHeaders={tableHeaders}
                            data={machineList}
                            fetchAllMachines={fetchAllMachines}
                          />
                        </>
                      ) : (
                        <div className="row">
                          <div className="px-4">
                            <div className="first-event">
                              No Machine Found!
                              {userData?.user?.permissions?.includes("MACHINE.ADD") && (
                                <button className="plain-btn" onClick={() => navigate(`/machine-list/create`)}>
                                  Add New Machine
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <Skeleton width="15vw" height="40px" baseColor="#ffffff99" />
                        <Skeleton width="15vw" height="40px" baseColor="#ffffff99" />
                      </div>
                      <div className="table-responsive machinelist workflowtb mt-3">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th className="text-center">SNo</th>
                              <th>Machine Name</th>
                              <th className="text-center">Machine Id</th>
                              <th className="text-center">Tags</th>
                              <th className="text-center">Visibility</th>
                              <th className="text-center">QR Code</th>
                            </tr>
                          </thead>
                          <tbody>{tableList}</tbody>
                        </table>
                      </div>
                    </>
                  )}
                </section>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="groups">
              <GroupList setActiveTab={setActiveTab} navigateLink={"/machine-list/view"} />
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>

      {
        <AddItem
          addMachine={addMachine}
          setAddMachine={setAddMachine}
          onSaveMachine={onSaveMachine}
          loadingBtn={loadingBtn}
          setLoadingBtn={setLoadingBtn}
        />
      }
    </>
  );
};

export default MachineList;
